/* eslint-disable no-continue */
/* eslint-disable no-unused-expressions */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useCallback, useMemo, useState, useRef } from "react";
import { useSelector, shallowEqual, useDispatch } from "react-redux";
import { Formik, Form, Field } from "formik";
import { withFormikDevtools } from "formik-devtools-extension";
import { isProduction } from "src/config/index";
import PropTypes from "prop-types";
import { useLocation } from 'react-router';
// import { DATE_TIME_FORMAT } from 'src/constants/CommonConstants';
import FormikCreateSearchClear from "src/components/formik/FormikCreateSearchClear";
import FormikDateTimePicker from "src/components/formik/FormikDateTimePicker";
import Table from "src/components/table/Table";
import { set } from "lodash";
import { getEndOfDay, getStartOfDay } from "src/utils/DadeUtils";
import {
  caseEditAction,
  caseResetAction,
  caseSearchAction,
} from "../case-container/actions/CaseActions";
import { headerShowAction } from "../header-container/actions/HeaderActions";
import RoutingUtil from "src/utils/RoutingUtil";
import OpenNewTabLink from "src/components/OpenNewTabLink";
import { userSearchAPI } from "src/api/UserApi";
import {
  PRODUCT_CATEGORY_TYPES_LIST,
  CAR_LOAN_TYPE_LIST,
  USED_CAR_LOAN_TYPE_LIST,
  ProductCategoryTypesData,
  VEHICLE_STATUS_TYPES_LIST,
} from "../product-container/ProductConstants";
import CompanyDropDown from "src/business-components/CompanyDropDown";
import UserDropDown from "src/business-components/UserDropDown";
import CommissionManagerDropDown from "src/business-components/CommissionManagerDropDown";
import FormikSelect from "src/components/formik/FormikSelect";
import { PAYOUT } from "../company-container/CompanyConstants";
import FormikCheckBox from "src/components/formik/FormikCheckBox";
import { caseInvoiceCreateAPI, pipelineApi } from "src/api/CaseApi";
import LinkComponent from "src/components/LinkComponent";
import { Route, Switch } from "react-router-dom";
import Invoice from "./Invoice";
import { useHistory } from "react-router";
import { commissionSearchAction } from "../commission-container/actions/CommissionActions";
import { commissionSearchAPI } from "src/api/CommissionApi";
import CustomerDropDown from "src/business-components/CustomerDropDown";
import FormikInput from "src/components/formik/FormikInput";
import { getGSTCalc, getTotalAmount } from "src/utils/CommonUtils";
import { EMPLOYMENT_TYPES_LIST, POLICY_TYPES_LIST } from "../user-container/UserConstants";
import { DATA_TYPE, DATE_TIME_FORMAT } from "src/constants/CommonConstants";
import { remarkSearchAPI } from "src/api/RemarkApi";
import { ExportReactCSV } from "src/components/excel/ExportReactCSV";
import { excelCaseSearchAction } from "../excel-container/actions/ExcelActions";
import { MASTERS_TYPES } from "../masters-container/MastersConstants";
import MastersDropDown from "src/business-components/MastersDropDown";

const RenderFilters = (props) => {
  // DEV TOOL
  if (!isProduction()) {
    withFormikDevtools(props);
  }

  const {
    // errors,
    // touched,
    isSubmitting,
    onClear,
    // forceRefreshSearchContainer,
    resetForm,
    values,
    activityList,
    userType,
    ExportInExcel,
    handleChange,
    generateInvoice,
    history,
    onPageChange,
    alertModalClass,
    alertDisplay,
    openAlertDialog,
    viewRemarks,
    editClick,
    grossAmount,
    grossODPremium,
    total,
  } = props;

  //Deepcopy of EMPLOYMENT_TYPES_LIST
  const Employment_List = JSON.parse(JSON.stringify(EMPLOYMENT_TYPES_LIST));
  Employment_List.push({
    value: 'onroll&dsa',
    label: 'Onroll&DSA',
  });

  return (
    <div>
      <div style={{ justifyContent: 'center', display: 'flex', padding: '20px' }}><h2>Insurance Report</h2></div>
      <div className="card">
        <div className="card-body">
          <h5 className="card-title">Search Filters</h5>
          <Form>
            <div className="form-row">
              <div className="form-group col-md-3">
                <label>Category</label>
                {/* <FormikSelect
                  items={PRODUCT_CATEGORY_TYPES_LIST}
                  name="productCategory"
                  className="form-control"
                  
                /> */}

                <Field
                  type="text"
                  className="form-control"
                  disabled
                  value="Insurance"
                  name="productCategory"
                  initialValue="VEHICLE_INSURANCE"
                />


              </div>
              {values.productCategory === "CAR_LOAN" && (
                <div className="form-group col-md-3">
                  <label>Loan Type</label>
                  <FormikSelect
                    items={CAR_LOAN_TYPE_LIST}
                    name="loanType"
                    className="form-control"
                  />
                </div>
              )}
              {values.productCategory === "CAR_LOAN" && values.loanType === "USED" && (
                <div className="form-group col-md-3">
                  <label>Used Car Loan Type</label>
                  <FormikSelect
                    items={USED_CAR_LOAN_TYPE_LIST}
                    name="usedCarLoanType"
                    className="form-control"
                  />
                </div>
              )}
              <div className="form-group col-md-3">
                <label>From Date</label>
                <FormikDateTimePicker
                  name="CaseFromDate"
                  className="form-control"
                  disableClock
                  format="dd-MM-y"
                  disabled={!!values.FilterCommissionId || !!values.by}
                />
              </div>
              <div className="form-group col-md-3">
                <label>To Date</label>
                <FormikDateTimePicker
                  name="CaseToDate"
                  className="form-control"
                  disableClock
                  format="dd-MM-y"
                  disabled={!!values.FilterCommissionId || !!values.by}
                />
              </div>
              <div className="form-group col-md-3">
                <label>Company</label>
                <CompanyDropDown name="companyId" value={values.companyId} />
              </div>
              <div className="form-group col-md-3">
                <label>Assigned Agent</label>
                <UserDropDown name="agentId" value={values.agentId} />
              </div>
              <div className="form-group col-md-3">
                <label>Reporting Manager</label>
                <UserDropDown name="reportingManagerId" value={values.reportingManagerId} />
              </div>
              <div className="form-group col-md-3">
                <label>BackendManager</label>
                <UserDropDown name="reportingManagerBackendId" value={values.reportingManagerBackendId} />
              </div>
              <div className="form-group col-md-6">
                <label>Customer</label>
                <CustomerDropDown name="customerId" value={values.customerId} />
              </div>
              <div className="form-group col-md-3">
                <label>Vehicle Number</label>
                <FormikInput
                  name="vehicleNumber"
                  type="text"
                  placeholder="enter Vehicle Number for filter e.g DLB64620"
                  className="form-control"
                />
              </div>
              <div className="form-group col-md-3">
                <label>Employment Type</label>
                <FormikSelect
                  items={Employment_List}
                  name="employmentType"
                  className="form-control"
                />
              </div>
              <div className="form-group col-md-3">
                <label>Policy Number</label>
                <FormikInput
                  name="LoanPolicyNumber"
                  type="text"
                  placeholder="Policy Number"
                  value={values.LoanPolicyNumber}
                  className="form-control"
                />
              </div>
              <div className="form-group col-md-3">
                <label>Engine Number</label>
                <FormikInput
                  name="engineNumber"
                  type="text"
                  placeholder="Engine Numbers"
                  className="form-control"
                />
              </div>
              <div className="form-group col-md-3">
                <label>Chasis Number</label>
                <FormikInput
                  name="chasisNumber"
                  type="text"
                  placeholder="Chasis Number"
                  className="form-control"
                />
              </div>
              <div className="form-group col-md-3">
                <label className="col-md-12">Policy Type</label>
                <MastersDropDown
                  name="policyType"
                  value={values?.policyType || ''}
                  masterType={MASTERS_TYPES.POLICY_TYPE}
                />

              </div>
              <div className="form-group col-md-3">
                <label>Business Type</label>
                <FormikSelect
                  items={VEHICLE_STATUS_TYPES_LIST}
                  name="vehicleStatus"
                  className="form-control"
                />
              </div>
              <div className="form-group col-md-3">
                <label>Data entry operater</label>
                <UserDropDown name="by" value={values.by} />
              </div>
              {values.by && (
                <>
                  <div className="form-group col-md-3">
                    <label>From Date</label>
                    <FormikDateTimePicker
                      name="CaseTsFromDate"
                      className="form-control"
                      disableClock
                      format="dd-MM-y"
                    />
                  </div>
                  <div className="form-group col-md-3">
                    <label>To Date</label>
                    <FormikDateTimePicker
                      name="CaseTsToDate"
                      className="form-control"
                      disableClock
                      format="dd-MM-y"
                    />
                  </div>
                </>
              )}
            </div>

            <div className="text-center py-4 mt-3">
              <FormikCreateSearchClear
                isSubmitting={isSubmitting}
                onClear={onClear}
                resetForm={resetForm}
                submitButtonText="Search"
                submitScope="reports.insurance_list.search"
              />
            </div>
          </Form>
        </div>
      </div>
      <div className="border-top my-3" />
      <div className="card mt-3">
        <div className="card-body">
          <h5 className="card-title">
            Search Results
            <ExportReactCSV
              csvData={ExportInExcel}
              fileName={"Insurance-Report-" + new Date().toLocaleDateString()}
            />
          </h5>
          <div className="mb-2 border p-2 float-right">
            <span className="mr-2 border badge badge-secondary status-Total mb-2">
              <div>
                <label>Gross Amount</label>
                <div>
                  <input className="text-center font-weight-bold text-black" type="text" value={total?.totalGrossAmt || 0} disabled
                  />
                </div>
              </div>
            </span>
            <span className="mr-2 border badge badge-secondary status-Total mb-2">
              <div>
                <label>Gross OD Premium</label>
                <div>
                  <input className="text-center font-weight-bold text-black" type="text" value={total?.totalODPremium || 0} disabled
                  />
                </div>
              </div>
            </span>
            <span className="mr-2 border badge badge-secondary status-Total mb-2">
              <div>
                <label>Discount</label>
                <div>
                  <input className="text-center font-weight-bold text-black" type="text" value={total?.totalDiscount || 0} disabled
                  />
                </div>
              </div>
            </span>
          </div>
          <Table
            recordsPerPage={50}
            onPageChange={onPageChange}
            searchData={{
              data: activityList.data,
              count: activityList.count,
              currentPage: activityList.currentPageIndex,
            }}
            columns={{
              group: [
                {
                  display: "Name of Customer",
                  path: "customerName",
                },
                {
                  display: "Assigned Agent Name",
                  path: "agentName",
                },
                {
                  display: "Reporting Manager Name",
                  path: ["reportingManagerId.personalInfo.firstName", "reportingManagerId.personalInfo.lastName"],
                },
                {
                  display: "Backend Manager",
                  path: ["reportingManagerBackendId.personalInfo.firstName", "reportingManagerBackendId.personalInfo.lastName", "reportingManagerBackendId.personalInfo.phone"],
                },
                {
                  display: "Customer Mobile",
                  path: "customerId.phone",
                },
                {
                  display: "Insurance Company",
                  path: "companyId.companyName",
                },
                {
                  display: "Business Type",
                  path: "vehicleStatus",
                },
                {
                  display: "Brand Name",
                  path: "meta.vehicleProductId.manufacturer.companyName",
                },
                {
                  display: "Vehicle Model",
                  path: "meta.vehicleProductId.productName",
                },
                {
                  display: "Cubic Capacity",
                  path: "meta.vehicleProductId.meta.cubicCapacity",
                },
                {
                  display: "Fuel Type",
                  path: "meta.vehicleProductId.meta.fuelType",
                },
                {
                  display: "Policy Issue Date",
                  type: Date,
                  format: DATE_TIME_FORMAT.DATE,
                  path: "coverNotes.cn_date"
                },
                {
                  display: "Model Year",
                  path: "meta.vehicleModelYear"
                },
                {
                  display: "Vehicle Number",
                  path: "meta.vehicleNumber",
                },
                {
                  display: "Engine Number",
                  path: "meta.engineNumber",
                },
                {
                  display: "Chasis Number",
                  path: "meta.chasisNumber",
                },
                {
                  display: "Policy Number",
                  path: "coverNotes.cn_number",
                },
                {
                  display: "Effective Date",
                  type: Date,
                  format: DATE_TIME_FORMAT.DATE,
                  path: "coverNotes.effective_date"
                },
                {
                  display: "Expiry Date",
                  type: Date,
                  format: DATE_TIME_FORMAT.DATE,
                  path: "expiryDate"
                },
                {
                  display: "Third-Party Expiry Date",
                  type: Date,
                  format: DATE_TIME_FORMAT.DATE,
                  path: "coverNotes.third_party_exp_date"
                },
                {
                  display: "Policy Type",
                  path: "policyType.masterName"
                },
                {
                  display: "Vehicle IDV Value",
                  type: DATA_TYPE.Decimal,
                  path: "coverNotes.vehicleIdvValue",
                },
                {
                  display: "Total Policy Premium",
                  type: DATA_TYPE.Decimal,
                  path: "coverNotes.totalPolicyPremium",
                },
                {
                  display: "NCB (%)",
                  type: DATA_TYPE.Decimal,
                  path: "coverNotes.ncbPercentage",
                },
                {
                  display: "OD Discount (%)",
                  type: DATA_TYPE.Decimal,
                  path: "coverNotes.odDiscountPercentage",
                },
                {
                  display: "Insurance OD Premium",
                  type: DATA_TYPE.Decimal,
                  path: "coverNotes.odPremium",
                },
                {
                  display: "Insurance Company Payout Rate(%)",
                  type: DATA_TYPE.Decimal,
                  path: "companyCommissionPercentage",
                },
                {
                  display: "Discount Amount Pass to customer",
                  type: DATA_TYPE.Decimal,
                  path: "coverNotes.discountPassToCustomer",
                },
                {
                  display: "Agent Payout Rate(%)",
                  type: DATA_TYPE.Decimal,
                  path: "agentCommissionPercentage",
                },
                {
                  display: "1st Payment Date",
                  type: Date,
                  format: DATE_TIME_FORMAT.DATE,
                  path: "payments[0].payment_date",
                },
                {
                  display: "1st Instrument Number",
                  path: "payments[0].instrument_number"
                },

                {
                  display: "1st Bank Name",
                  path: "payments[0].bank_name",
                },


                {
                  display: "1st Amount",
                  type: DATA_TYPE.Decimal,
                  path: "payments[0].amount",
                },

                {
                  display: "1st Is Paid by Us?",
                  path: "payments[0].is_paid_by_us",
                },
                {
                  display: "2nd Payment Date",
                  type: Date,
                  format: DATE_TIME_FORMAT.DATE,
                  path: "payments[1].payment_date",
                },
                {
                  display: "2nd Instrument Number",
                  path: "payments[1].instrument_number"
                },

                {
                  display: "2nd Bank Name",
                  path: "payments[1].bank_name",
                },


                {
                  display: "2nd Amount",
                  type: DATA_TYPE.Decimal,
                  path: "payments[1].amount",
                },

                {
                  display: "2nd Is Paid by Us?",
                  path: "payments[1].is_paid_by_us",
                },
                {
                  display: "LOS No.",
                  path: "coverNotes.losNo",
                },
                {
                  display: "Insu. Agent Code",
                  path: "coverNotes.InsUAgentCode",
                },
                {
                  display: "Created By",
                  path: "by.personalInfo.firstName",
                },
              ],
            }}
            // rowColoring={[
            //   // list should be priority wise
            //   {
            //     reason: 'Pending',
            //     rowClass: 'status-pending',
            //     shouldApply: (record) => (record.isPending),
            //   },
            //   {
            //     reason: 'Critical',
            //     rowClass: 'status-critical',
            //     shouldApply: (record) => (record.isCritical),
            //   },
            // ]}
            customActions={[
              {
                heading: "View Remarks",
                Render: ({ record }) => {
                  return (
                    <LinkComponent onClick={() => viewRemarks(record._id)}>
                      <i className="fas fa-eye " />
                    </LinkComponent>
                  );
                },
              },
              {
                heading: "View Case Manager",
                Render: ({ record }) => {
                  return (
                    <LinkComponent onClick={() => editClick(record)}>
                      <i className="fas fa-pen" />
                    </LinkComponent>
                  );
                },
              },
            ]}
          />
        </div>
      </div>
    </div>
  );
};

RenderFilters.propTypes = {
  isSubmitting: PropTypes.bool.isRequired,
  onClear: PropTypes.func.isRequired,
  resetForm: PropTypes.func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  values: PropTypes.any.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  // activityList: PropTypes.Object.isRequired,
};

// setting submit button state after submitting
const filterDefaultValues = {
  productCategory: "VEHICLE_INSURANCE",
  verifierId: "",
  clientId: "",
  branchId: "",
  CaseFromDate: null, //new Date(new Date().getFullYear(), new Date().getMonth(), 1),
  CaseToDate: null, //new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0),
  caseId: "",
  caseStatus: "",
  overAllcaseStatus: "",
  LoanPolicyNumber: ""
};

const RptInsuranceList = () => {

  const history = useHistory();
  const { location: { state } } = history;
  let filters = state?.filters || null;

  const [filterInitialValues, setFilterInitialValues] = useState(filters || {
    ...filterDefaultValues,
  });

  const [currentProductCategory, setProductCategory] = useState(ProductCategoryTypesData.VEHICLE_INSURANCE);

  const [currentCompany, setCurrentCompany] = useState();

  const [currentActivityAssignedDateTill, setCurrentActivityAssignedDateTill] =
    useState();

  const [currentActivityAssignedDateFrom, setCurrentActivityAssignedDateFrom] =
    useState();

  const [invoiceInitialValues, setInvoiceInitialValues] = useState([]);

  const [where, setWhere] = useState({});

  const [currentPageIndex, setCurrentPageIndex] = useState(0);

  const [alertModalClass, setAlertModalClass] = useState(false);
  const [alertDisplay, setAlertDisplay] = useState(false);

  const [remarksModalClass, setRemarksModalClass] = useState(false);
  const [remarksDisplay, setRemarksDisplay] = useState(false);
  const [remarksDetails, setRemarksDetails] = useState([]);

  const [commissionMaster, setCommissionMaster] = useState({ slab: [] });
  const [grossAmount, setGrossAmount] = useState(0)
  const [grossODPremium, setGrossODPremium] = useState(0)
  const [total, setTotal] = useState({})

  const openAlertDialog = () => {
    setRemarksDisplay("block");
    setRemarksModalClass("show");
    if (document.body.style.overflow !== "hidden") {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "scroll";
    }
  };
  const closeAlertDialog = () => {
    setRemarksModalClass("none");
    setRemarksDisplay("");
    if (document.body.style.overflow !== "scroll") {
      document.body.style.overflow = "scroll";
    } else {
      document.body.style.overflow = "hidden";
    }
  };

  let data = [];
  // REDUX
  const dispatch = useDispatch();
  const location = useLocation();
  const isRenualAlert = (location.pathname.split("/").pop() === "insurance-renewal-alert") ? true : false;

  const {
    search: { data: searchResults, count },
  } = useSelector((state) => state.CaseReducer, shallowEqual);

  const {
    search: { data: excelSearchResults, excelCount },
  } = useSelector((state) => state.ExcelReducer, shallowEqual);

  const { userType, userId } = useSelector(
    (state) => state.AuthReducer,
    shallowEqual
  );


  const getPayout = (caseInfo, type) => {
    let amount = 0;
    let ExtingAmount = 0;
    const PayoutPercentage = type == "Payout" ? caseInfo.agentCommissionPercentage : caseInfo.companyCommissionPercentage;

    amount = Math.round(((
      caseInfo.coverNotes.odPremium) * PayoutPercentage) / 100, 2);

    const paymentDetails = type === "Payout" ? caseInfo.paymentDetails : caseInfo.recieptDetails;
    ExtingAmount = paymentDetails?.reduce((sum, payment) => sum + payment.amount, 0);

    amount -= ExtingAmount || 0;
    return isNaN(amount) ? 0 : amount;
  };
  const getCommissionDetails = (totalGrossAmt) => {
    let commissionDT = []; //{ commissionTarget: 0, tillNow: 0, Status: "Short" };
    commissionMaster.slab.map((slab, index) => {
      // const lastTarget = commissionMaster.slab[index];
      const status = totalGrossAmt >= slab.target ? "Completed" : "Short";
      const amount = slab.target + (slab.target * slab.reward) / 100;
      commissionDT.push({
        commissionTarget: slab.target,
        tillNow: totalGrossAmt,
        reward: slab.reward,
        amount,
        status,
        isRewardPercentage: slab.isRewardPercentage,
      });
    });
    return commissionDT;
  };

  const activitiesFromSearch = useMemo(() => {
    if (!searchResults) {
      return [];
    }

    // //filters out the items which have their payments.delted flagged as true  
    // searchResults.forEach(item => {
    //   if (item.payments && Array.isArray(item.payments)) {
    //     item.payments = item.payments.filter(payment => !payment.deleted)
    //   }
    // })

    const PrepairData = [];
    let totalGrossAmt = 0;
    let totalGrossODPremium = 0;
    searchResults.forEach((caseInfo) => {

      // Filter out deleted payments
      if (caseInfo.payments && Array.isArray(caseInfo.payments)) {
        caseInfo.payments = caseInfo.payments.filter(payment => !payment.deleted);
      }

      const CrossSellAmount = caseInfo.meta.crossSaleAmount || 0;
      const gstCalc = caseInfo.companyId.GSTCalc;
      const DueAmount = getPayout(caseInfo, "Due");
      const payoutAmount = getPayout(caseInfo, "Payout");
      const difference = payoutAmount - DueAmount;
      const GSTEncExc = getGSTCalc(DueAmount, gstCalc);
      const agentName =
        caseInfo.agentId.personalInfo.firstName +
        " " +
        caseInfo.agentId.personalInfo.lastName +
        "-" +
        caseInfo.agentId.employmentType;
      const amount = caseInfo.meta.loanAmount - CrossSellAmount;
      const paymentAmount = getTotalAmount(caseInfo.paymentDetails);
      const receiptAmount = getTotalAmount(caseInfo.recieptDetails);
      const customerName = `${caseInfo.customerId.firstName} ${caseInfo.customerId.lastName}`;
      totalGrossAmt += caseInfo.coverNotes.totalPolicyPremium || 0;
      setGrossAmount(totalGrossAmt);
      totalGrossODPremium += caseInfo.coverNotes.odPremium || 0;
      setGrossODPremium(totalGrossODPremium)
      const loanType =
        caseInfo.meta.loanType + " " + (caseInfo.meta?.usedCarType || "");
      const policyIssueDate = new Date(caseInfo.coverNotes.cn_date);
      const effectiveDate = new Date(caseInfo.coverNotes.effective_date);
      const expiryDate = new Date(effectiveDate.getFullYear() + 1, effectiveDate.getMonth(), effectiveDate.getDate() - 1);
      // const exiryDate = caseInfo.coverNotes.effective_date
      const currentDate = new Date();
      // const otherDate = new Date(caseInfo.coverNotes.effective_date);
      const timeDifference = Math.abs(currentDate.getTime() - policyIssueDate.getTime());
      const dayCount = Math.ceil(timeDifference / (1000 * 3600 * 24));

      // const isPending = ((
      //   !caseInfo.meta.RCRecv ||
      //   !caseInfo.meta.insuranceRec ||
      //   !caseInfo.meta.invoiceRecv ||
      //   !caseInfo.meta.parivahanStatus ||
      //   !caseInfo.meta.rtoSlip) && (
      //     ((new Date() - new Date(caseInfo.coverNotes.effective_date)) >= 30 * 24 * 60 * 60 * 1000) &&
      //     ((new Date() - new Date(caseInfo.coverNotes.effective_date)) <= 60 * 24 * 60 * 60 * 1000))
      // );
      // const isCritical = ((
      //   !caseInfo.meta.RCRecv ||
      //   !caseInfo.meta.insuranceRec ||
      //   !caseInfo.meta.invoiceRecv ||
      //   !caseInfo.meta.parivahanStatus ||
      //   caseInfo.meta.rtoSlip) && (
      //     ((new Date() - new Date(caseInfo.coverNotes.effective_date)) >= 61 * 24 * 60 * 60 * 1000))
      // );

      PrepairData.push({
        ...caseInfo,
        difference,
        payoutAmount,
        DueAmount,
        CrossSellAmount,
        GSTEncExc,
        agentName,
        amount,
        paymentAmount,
        receiptAmount,
        loanType,
        customerName,
        // isPending,
        // isCritical,
        dayCount,
        expiryDate,
      });
    });

    const commissionDetails = getCommissionDetails(totalGrossAmt);
    const results = {
      data: PrepairData,
      count,
      currentPageIndex,
      commissionDetails,
    };

    return results;
  }, [
    searchResults,
    currentProductCategory,
    currentActivityAssignedDateFrom,
    currentActivityAssignedDateTill,
    currentCompany,
    currentPageIndex,
  ]);

  // PAGE CHANGE
  const onPageChange = useCallback(
    (currentPage) => {
      setCurrentPageIndex(currentPage);
      dispatch(
        caseSearchAction({
          where,
          currentPage,
          fullTextSearch: true,
        })
      );
    },
    [
      dispatch,
      caseSearchAction,
      where,
      currentPageIndex,
      // currentPage,
      // where,
      // fullTextSearch,
    ]
  );

  const onSearchSubmit = useCallback(
    async (values, formikUtils) => {
      formikUtils.setSubmitting(false);
      const {
        productCategory,
        loanType,
        usedCarLoanType,
        CaseFromDate,
        CaseToDate,
        companyId,
        agentId,
        reportingManagerId,
        reportingManagerBackendId,
        FilterCommissionId,
        customerId,
        vehicleNumber,
        employmentType,
        LoanPolicyNumber,
        engineNumber,
        chasisNumber,
        policyType,
        vehicleStatus,
        grossAmount,
        grossODPremium,
        by,
        CaseTsFromDate,
        CaseTsToDate
      } = values;

      if (by) {
        if (!CaseTsFromDate || !CaseTsToDate) {
          dispatch(
            headerShowAction({
              data: "CaseFromDate and CaseToDate are required when Data entery Operater is provided.",
            })
          );
          return;
        }
        if (CaseFromDate || CaseToDate) {
          dispatch(
            headerShowAction({
              data: "CaseFromDate and CaseToDate should not be used when Data entery Operater is provided.",
            })
          );
          return;
        }
      } else {
        if (!CaseFromDate || !CaseToDate) {
          dispatch(
            headerShowAction({
              data: "CaseFromDate and CaseToDate are required filters.",
            })
          );
          return;
        }
      }



      // if (
      //   // THERE MUST BE AT LEAST ONE FILTER
      //   [
      //     productCategory,
      //     loanType,
      //     usedCarLoanType,
      //     CaseFromDate,
      //     CaseToDate,
      //     companyId,
      //     FilterCommissionId,
      //     agentId,
      //     reportingManagerId,
      //     customerId,
      //     vehicleNumber,
      //     employmentType,
      //     LoanPolicyNumber,
      //     engineNumber,
      //     chasisNumber,
      //     policyType,
      //   ].filter((item) => !!item).length < 1
      // ) {
      //   dispatch(
      //     headerShowAction({
      //       data: "There must at least one filter to be added.",
      //     })
      //   );
      //   return;
      // }

      let where = {};

      // product Category
      if (productCategory) {
        set(where, "productCategory", productCategory);
        setProductCategory(productCategory);
      } else {
        setProductCategory(null);
      }
      // set(where, "productCategory", "VEHICLE_INSURANCE");

      if (loanType) {
        set(where, "meta.loanType", loanType)
      }
      if (usedCarLoanType)
        set(where, "meta.usedCarType", usedCarLoanType)
      // company
      if (companyId) {
        set(where, "companyId", companyId);
        setCurrentCompany(companyId);
      } else {
        setCurrentCompany(null);
      }

      // FROM
      if (CaseFromDate && !Number.isNaN(CaseFromDate.getTime())) {
        const fromDate = getStartOfDay(CaseFromDate);
        setCurrentActivityAssignedDateFrom(CaseFromDate);
        set(where, "coverNotes.cn_date", { $gte: fromDate });
      } else {
        setCurrentActivityAssignedDateFrom(null);
      }

      // TILL
      if (CaseToDate && !Number.isNaN(CaseToDate.getTime())) {
        const tillDate = getEndOfDay(CaseToDate);
        const fromDate = getStartOfDay(CaseFromDate);
        setCurrentActivityAssignedDateTill(CaseToDate);

        set(where, "coverNotes.cn_date", { $lte: tillDate });
        if (fromDate)
          set(where, "coverNotes.cn_date", { $lte: tillDate, $gte: fromDate });
      } else {
        setCurrentActivityAssignedDateTill(null);
      }

      // CLIENT
      if (agentId) {
        where.agentId = agentId;
      }
      if (reportingManagerId) {
        where.reportingManagerId = reportingManagerId;
      }
       if (reportingManagerBackendId) {
        where.reportingManagerBackendId = reportingManagerBackendId;
      }
      //CUSTOMER
      if (customerId) {
        where.customerId = customerId;
      }
      //vehicleNumber
      if (vehicleNumber) {
        const lastFourDigits = vehicleNumber.slice(-4);
        set(where, "meta.vehicleNumber", { $regex: `${lastFourDigits}` });
      }
      // CommissionId
      if (FilterCommissionId) {
        where = {};
        set(where, "invoiceDetails.commissionId", FilterCommissionId);
        const commissionId = { _id: FilterCommissionId };
        let {
          data: {
            data: { data: commissionMasterDT },
          },
        } = await commissionSearchAPI({
          where: {
            ...commissionId,
          },
          autopopulate: false,
        });
        commissionMasterDT = commissionMasterDT[0];
        setCommissionMaster(commissionMasterDT);
        const fromDate = getStartOfDay(commissionMasterDT.FromDate);
        set(where, "ts", { $gte: fromDate });
        setCurrentActivityAssignedDateFrom(fromDate);
        values.CaseFromDate = fromDate;
        const tillDate = getEndOfDay(commissionMasterDT.ToDate);
        set(where, "ts", { $lte: tillDate });
        setCurrentActivityAssignedDateTill(tillDate);
        values.CaseToDate = tillDate;

        if (commissionMasterDT.loanType)
          set(where, "loanType", commissionMasterDT.loanType);
        if (
          commissionMasterDT.loanType == "USED" &&
          commissionMasterDT.usedCarType
        )
          set(where, "usedCarType", commissionMasterDT.usedCarType);
      } else {
        // setCurrentCompany(null);
      }
      if (employmentType) {
        const fetchUserIds = async (type, currentPage = 0) => {
          let allUserIds = [];
          let { data: { data: { data: userIdsChunk, pages } } } = await userSearchAPI({
            where: { employmentType: type },
            currentPage,
          });

          allUserIds = [...allUserIds, ...userIdsChunk.map(user => user._id)];
          const totalPages = pages;
          if (currentPage < totalPages) {
            const remainingUserIds = await fetchUserIds(type, currentPage + 1);
            allUserIds = [...allUserIds, ...remainingUserIds];
          }

          return allUserIds;
        };
        const getUserIds = async (employmentType) => {
          if (employmentType === "onroll&dsa") {
            const onRollUserIds = await fetchUserIds("ON_ROLL");
            const dsaUserIds = await fetchUserIds("DSA");
            return [...onRollUserIds, ...dsaUserIds];
          }
          return await fetchUserIds(employmentType);
        };

        const userIds = await getUserIds(employmentType);

        set(where, "agentId", { $in: userIds });
      }
      //LoanPolicyNumber
      if (LoanPolicyNumber) {
        const lastFourDigits = LoanPolicyNumber.slice(-4);
        set(where, "coverNotes.cn_number", { $regex: `${lastFourDigits}` });
        // set(where, "coverNotes.cn_number", LoanPolicyNumber);
      }
      // if (LoanPolicyNumber) {
      //   if (productCategory === "VEHICLE_INSURANCE")
      //     set(where, "coverNotes.cn_number", LoanPolicyNumber)
      //   else
      //     set(where, "meta.LoanAccountNo", LoanPolicyNumber)
      // }
      //Engine Number
      if (engineNumber) {
        set(where, "meta.engineNumber", engineNumber);
      }
      //Chasis Number
      if (chasisNumber) {
        set(where, "meta.chasisNumber", chasisNumber);
      }
      //policyType
      if (policyType) {
        set(where, "policyType", policyType);
      }
      //vehicleStatus
      if (vehicleStatus) {
        set(where, "vehicleStatus", vehicleStatus)
      }
      if (by) {
        set(where, "by", by);
      }
      //ts from
      if (CaseTsFromDate && !Number.isNaN(CaseTsFromDate.getTime())) {
        const fromDate = getStartOfDay(CaseTsFromDate);
        setCurrentActivityAssignedDateFrom(CaseTsFromDate);
        console.log('where', where)
        set(where, "ts", { $gte: fromDate });
      } else {
        setCurrentActivityAssignedDateFrom(null);
      }
      //ts till
      if (CaseTsToDate && !Number.isNaN(CaseTsToDate.getTime())) {
        const tillDate = getEndOfDay(CaseTsToDate);
        const fromDate = CaseTsFromDate && !Number.isNaN(CaseTsFromDate.getTime()) ? getStartOfDay(CaseTsFromDate) : null;

        setCurrentActivityAssignedDateTill(CaseTsToDate);

        if (fromDate) {
          set(where, "ts", { $lte: tillDate, $gte: fromDate });
        } else {
          set(where, "ts", { $lte: tillDate });
        }
      } else {
        setCurrentActivityAssignedDateTill(null);
      }

      setWhere(where);
      pipeline(where)
      dispatch(
        excelCaseSearchAction({
          where,
          sortBy: "ts",
          sortOrder: -1,
          fullTextSearch: false,
        })
      );

      dispatch(
        caseSearchAction({
          where,
          currentPage: 0,
          sortBy: "ts",
          sortOrder: -1,
          fullTextSearch: false,
          pageLength: 50,
        })
      );
    },
    [dispatch]
  );

  const pipeline = async (where) => {

    // Stage 2: Calculate payoutAmount
    const calculatePayoutStage = {
      $addFields: {
        payoutAmount: {
          $round: {
            $multiply: [
              "$coverNotes.odPremium",
              {
                $divide: [
                  "$agentCommissionPercentage",
                  100
                ]
              }
            ]
          }
        }
      }
    };

    // Stage 3: Calculate existing amount for payoutAmount
    const calculateExistingAmountForPayout = {
      $addFields: {
        existingAmountForPayout: {
          $cond: [
            { $ifNull: ["$paymentDetails", true] },
            0,
            {
              $reduce: {
                input: "$paymentDetails",
                initialValue: 0,
                in: { $sum: ["$$value", "$$this.amount"] }
              }
            }
          ]
        }
      }

    }
    // Stage 4: Calculate grand total payoutAmount
    const calculatePayoutAmountStage = {
      $addFields: {
        finalPayoutAmount: { $subtract: ["$payoutAmount", "$existingAmountForPayout"] }
      }
    };
    // Stage 5: Calculate dueAmount
    const calculateDueAmount = {
      $addFields: {
        dueAmount: {
          $round: {
            $multiply: [
              "$coverNotes.odPremium",
              {
                $divide: [
                  "$companyCommissionPercentage",
                  100
                ]
              }
            ]
          }
        }
      }
    };
    // Stage 6: Calculate existing amount for due
    const calculateExistingAmountForDue = {
      $addFields: {
        existingAmountForDue: {
          $cond: [
            { $ifNull: ["$recieptDetails", true] },
            0,
            {
              $reduce: {
                input: "$recieptDetails",
                initialValue: 0,
                in: { $sum: ["$$value", "$$this.amount"] }
              }
            }
          ]
        }
      }

    }
    // Stage 7: Calculate grand total dueAmount
    const calculateDueAmountStage = {
      $addFields: {
        finalDueAmount: { $subtract: ["$dueAmount", "$existingAmountForDue"] }
      }
    };
    // Stage 8: Group and calculate totals
    const groupStage = {
      $group: {
        _id: null,
        totalGrossAmt: {
          $sum: {
            $ifNull: ['$coverNotes.totalPolicyPremium', 0]
          }
        },
        totalODPremium: {
          $sum: {
            $ifNull: ['$coverNotes.odPremium', 0]
          }
        },
        totalDiscount: {
          $sum: {
            $ifNull: ['$coverNotes.discountPassToCustomer', 0]
          }
        },
        // totalPayoutAmount: {
        //   $sum: "$finalPayoutAmount"
        // },
        // totalExistingAmountForPayout:{
        //   $sum: '$existingAmountForPayout'
        // },
        // totalDueAmount: {
        //   $sum: "$finalDueAmount"
        // },
        // totalExistingAmountForDue:{
        //   $sum: '$existingAmountForDue'
        // },
        count: { $sum: 1 },
      }
    };

    // Stage 9: Project required fields
    const projectStage = {
      $project: {
        _id: 0,
        totalGrossAmt: 1,
        totalODPremium: 1,
        totalDiscount: 1,
        // totalPayoutAmount: 1,
        // totalExistingAmountForPayout:1,
        // totalDueAmount: 1,
        // totalExistingAmountForDue:1,
        count: 1
      }
    };
    // Combine all stages into the pipeline array
    const pipelineStages = [
      // calculatePayoutStage,
      // calculateExistingAmountForPayout,
      // calculatePayoutAmountStage,
      // calculateDueAmount,
      // calculateExistingAmountForDue,
      // calculateDueAmountStage,
      groupStage,
      projectStage
    ];

    const pipelineHelper = {
      where,
      pipelineStages
    }
    let {
      data: {
        data: [totalPipe]
      }
    } = await pipelineApi(pipelineHelper);
    setTotal(totalPipe)
  }

  const onClear = useCallback(() => {
    dispatch(caseResetAction());
    setFilterInitialValues({
      ...filterDefaultValues,
    });
  }, [dispatch]);

  const generateInvoice = useCallback(
    async (commissionId) => {
      const payload = {
        commissionId: commissionId,
        data: invoiceInitialValues,
      };
      const invoice = await caseInvoiceCreateAPI(payload);
      closeAlertDialog();
      dispatch(
        headerShowAction({
          data: "Invoice has been created successfully.",
        })
      );
    },
    [invoiceInitialValues]
  );
  const handleChange = useCallback(
    (e) => {
      const id = e.target.name;
      const checked = e.target.value;

      if (checked == "false")
        setInvoiceInitialValues([...invoiceInitialValues, id]);
      else
        setInvoiceInitialValues(
          invoiceInitialValues.filter((item) => {
            return id !== item;
          })
        );

      // setInvoiceInitialValues(id)

      // data.push(id);
      // console.log("checked", checked);
      // console.log("invoiceInitialValues=>", invoiceInitialValues);
      // if()
      // else
      // console.log('invoiceInitialValues=>', invoiceInitialValues, data);

      return data;
    },
    [
      // dispatch,
      invoiceInitialValues,
    ]
  );

  const ExportInExcel = useMemo(() => {
    if (!excelSearchResults) {
      return [];
    }
    const results = [];
    let totalGrossAmt = 0;

    excelSearchResults.forEach((caseInfo) => {
      // Filter out deleted payments
      if (caseInfo.payments && Array.isArray(caseInfo.payments)) {
        caseInfo.payments = caseInfo.payments.filter(payment => !payment.deleted);
      }
      const CrossSellAmount = caseInfo.meta.crossSaleAmount || 0;
      const gstCalc = caseInfo.companyId.GSTCalc;
      const DueAmount = getPayout(caseInfo, "Due");
      const payoutAmount = getPayout(caseInfo, "Payout");
      const difference = payoutAmount - DueAmount;
      const GSTEncExc = getGSTCalc(DueAmount, gstCalc);
      const agentName =
        caseInfo.agentId.personalInfo.firstName +
        " " +
        caseInfo.agentId.personalInfo.lastName +
        "-" +
        caseInfo.agentId.employmentType;
      const amount = caseInfo.meta.loanAmount - CrossSellAmount;
      const paymentAmount = getTotalAmount(caseInfo.paymentDetails);
      const receiptAmount = getTotalAmount(caseInfo.recieptDetails);
      const customerName = `${caseInfo.customerId.firstName} ${caseInfo.customerId.lastName}`;
      totalGrossAmt += caseInfo.meta.grossLoanAmount || 0;
      const payment = caseInfo.payments[0] === undefined ? '' : caseInfo.payments[0];
      const payment1 = caseInfo.payments[1] === undefined ? '' : caseInfo.payments[1];
      const effectiveDate = new Date(caseInfo.coverNotes.effective_date);
      const expiryDate = new Date(effectiveDate.getFullYear() + 1, effectiveDate.getMonth(), effectiveDate.getDate() - 1);
      const PIDdate = new Date(caseInfo.coverNotes.cn_date);
      const EffectiveDate = new Date(caseInfo.coverNotes.effective_date);
      const thirdPartyExpDt = caseInfo.coverNotes.third_party_exp_date === null ? 'NA' : caseInfo.coverNotes.third_party_exp_date;
      const thrdPED = new Date(thirdPartyExpDt);
      const pay1D = new Date(payment.payment_date);
      const pay2D = new Date(payment1.payment_date);
      const currD = new Date(caseInfo.ts);
      // const formattedPID = `${PIDdate.getDate()}-${(PIDdate.getMonth() + 1).toString().padStart(2, '0')}-${PIDdate.getFullYear()}`;
      const dateOptions = {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      };
      const formattedExpiryDate = expiryDate.toLocaleDateString('en-GB', dateOptions);
      const formattedPID = PIDdate.toLocaleDateString('en-GB', dateOptions);
      const formattedEffD = EffectiveDate.toLocaleDateString('en-GB', dateOptions);
      const formattedTPED = thrdPED.toLocaleDateString('en-GB', dateOptions);
      const formattedPay1 = pay1D.toLocaleDateString('en-GB', dateOptions);
      const formattedPay2 = pay2D.toLocaleDateString('en-GB', dateOptions);
      const formattedCD = currD.toLocaleDateString('en-GB', dateOptions);
      results.push({
        "Name Of Customer": customerName,
        "Assigned Agent Name":
          (caseInfo.agentId?.personalInfo?.firstName || '') +
          " " +
          (caseInfo.agentId?.personalInfo?.lastName || ''),
        "Employment Type": caseInfo?.agentId?.employmentType || '',
        "Reporting Manager Name":
          (caseInfo.reportingManagerId?.personalInfo?.firstName || '') +
          " " +
          (caseInfo.reportingManagerId?.personalInfo?.lastName || ''),
          "Backend Manager Name":
          caseInfo.reportingManagerBackendId?.personalInfo.firstName + " " +
          caseInfo.reportingManagerBackendId?.personalInfo.lastName,
        "Customer Mobile": caseInfo.customerId.phone,
        "Manufacturer/Company": caseInfo.companyId.companyName,
        "Business Type": caseInfo.vehicleStatus,
        "Vehicle Name": caseInfo.meta.vehicleProductId.productName,
        "Policy Issue Date": formattedPID === "Invalid Date" ? 'NA' : formattedPID,
        "Model Year": caseInfo.meta.vehicleModelYear,
        "Vehicle Number": caseInfo.meta.vehicleNumber,
        "Engine Number": caseInfo.meta.engineNumber,
        "Chasis Number	": caseInfo.meta.chasisNumber,
        "Policy Number": caseInfo.coverNotes.cn_number,
        "Effective Date": formattedEffD === "Invalid Date" ? 'NA' : formattedEffD,
        "Expiry Date": expiryDate === "Invalid Date" ? 'NA' : formattedExpiryDate,
        "Third-Party Expiry Date": formattedTPED === 'Invalid Date' ? 'NA' : formattedTPED,
        "Policy Type": !caseInfo?.policyType?.masterName ? 'NA' : caseInfo?.policyType?.masterName,
        "Vehicle IDV Value": caseInfo.coverNotes.vehicleIdvValue,
        "Total Policy Premium": caseInfo.coverNotes.totalPolicyPremium,
        "NCB (%)": caseInfo.coverNotes.ncbPercentage,
        "OD Discount (%)": caseInfo.coverNotes.odDiscountPercentage,
        "Insurance OD Premium": caseInfo.coverNotes.odPremium,
        "Discount Amount Pass To Customer": caseInfo.coverNotes.discountPassToCustomer,
        "1st Payment Date": formattedPay1 === 'Invalid Date' ? 'NA' : formattedPay1,
        "1st Instrument Number": `'${payment.instrument_number}'`,
        "1st Bank Name	": payment.bank_name,
        "1st Amount": payment.amount,
        "1st Is Paid By Us?": payment.is_paid_by_us === true ? 'YES' : 'NO',
        "2nd Payment Date": formattedPay2 === 'Invalid Date' ? 'NA' : formattedPay2,
        // "2nd Instrument Number": payment1.instrument_number, //this wont retain leading zeros
        "2nd Instrument Number": `'${payment1.instrument_number}'`, //this will retain leading zeros but with quotes included like this '00345' 
        "2nd Bank Name	": payment1.bank_name,
        "2nd Amount": payment1.amount,
        "2nd Is Paid By Us?": payment1.is_paid_by_us === true ? 'YES' : 'NO',
        "LOS No.": caseInfo.coverNotes.losNo,
        "Insu. Agent Code": caseInfo.coverNotes.InsUAgentCode,
        "Created By": caseInfo.by.personalInfo.firstName,
        Date: formattedCD ? formattedCD : 'NA',
      });
    });

    return results;
  }, [
    excelSearchResults,
    currentProductCategory,
    currentActivityAssignedDateFrom,
    currentActivityAssignedDateTill,
    currentCompany,
  ]);
  const viewRemarks = async (id) => {
    openAlertDialog("remarks");
    if (!id) return;

    let where = {
      refId: id,
      deleted: false,
      source: "cases",
    };

    const {
      data: {
        data: { data: remarks },
      },
    } = await remarkSearchAPI({
      where,
      sortBy: "ts",
      pageLength: 0,
      currentPage: 1,
      autopopulate: false,
    });
    setRemarksDetails(remarks);
  };

  // EDIT
  const editClick = useCallback((record) => {
    dispatch(caseEditAction(record));
    history.push(RoutingUtil.caseManagerUrl());
  }, [
    dispatch,
    caseEditAction,
    history,
  ]);

  return (
    <div>
      <Formik
        onSubmit={onSearchSubmit}
        onClear={onClear}
        enableReinitialize
        initialValues={filterInitialValues}
      // validationSchema={}
      >
        {(formikProps) => (
          <RenderFilters
            // forceRefreshSearchContainer={forceRefreshSearchContainer}
            onClear={onClear}
            {...formikProps}
            activityList={activitiesFromSearch}
            userType={userType}
            ExportInExcel={ExportInExcel}
            handleChange={handleChange}
            generateInvoice={generateInvoice}
            history={history}
            onPageChange={onPageChange}
            alertModalClass={alertModalClass}
            alertDisplay={alertDisplay}
            openAlertDialog={openAlertDialog}
            viewRemarks={viewRemarks}
            editClick={editClick}
            grossAmount={grossAmount}
            grossODPremium={grossODPremium}
            total={total}
          />
        )}
      </Formik>
      {/* <div className={`modal fade ${(invoiceModal) ? 'show' : ''}`} id="exampleModal" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true"> */}
      <div
        className={`modal fade ${remarksModalClass}`}
        id="authAlert"
        style={{
          display: `${remarksDisplay}`,
          overflowY: "scroll",
          opacity: "1",
          background: "rgba(0, 0, 0, 0.5)",
        }}
      >
        <div className="modal-dialog modal-lg" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                View Remarks
              </h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={() => closeAlertDialog("remarks")}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="form-group col-md-12">
                <table className="table">
                  <thead>
                    <tr>
                      <th scope="col">Sr. No.</th>
                      <th scope="col">Remarks</th>
                    </tr>
                  </thead>
                  <tbody>
                    {remarksDetails.map((remark, index) => {
                      return (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{remark.text}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-dismiss="modal"
                onClick={() => closeAlertDialog("remarks")}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RptInsuranceList;
